import errorReporter from "./error_reporter"

if (window.gon?.currentUser) {
  errorReporter.setErrorPayload({
    person: {
      id: window.gon.currentUser.userId,
      email: window.gon.currentUser.email,
      colorBlindness: window.gon.colorBlindness
    }
  })
}